let bindingUnsubscribes = []

export const removeAllBindings = () => {
  bindingUnsubscribes.forEach((unsubscribe) => unsubscribe())
  bindingUnsubscribes = []
}

export const addBindingUnsubscribe = (unsubscribe) => {
  bindingUnsubscribes.push(unsubscribe)
}

export const firesBind = (
  sourceName,
  queryRefFunc,
  deps,
  vm,
  context,
  onExistsExtra,
  onNotExistsExtra,
  onSnapshotErrorExtra
) => {
  const bindingName = sourceName + 'Binding'

  const err = new Error('Dependencies (deps) must be an array of Strings.')

  deps = deps || []
  if (!Array.isArray(deps)) {
    throw err
  }
  deps.forEach((dep) => {
    if (typeof dep !== 'string') {
      throw err
    }
  })

  if (context.state[bindingName] && sourceName !== 'counterpartyUsers') {
    return context.state[bindingName]
  }

  context.commit(
    'set_' + bindingName,
    new Promise(async (resolve, reject) => {
      await Promise.all(deps.map((dep) => context.dispatch(dep)))

      const queryRef = queryRefFunc(context)

      try {
        const unsubscribe = queryRef.onSnapshot(
          async (snapshot) => {
            if ('exists' in snapshot) {
              // it's a (Query)DocumentSnapshot (single-doc)
              if (snapshot.exists) {
                context.commit('set_' + sourceName, {
                  ...snapshot.data(),
                  '.key': snapshot.id,
                  id: snapshot.id
                })
                if (onExistsExtra) {
                  onExistsExtra(context)
                }
              } else {
                context.commit('set_' + sourceName, {})
                if (onNotExistsExtra) {
                  onNotExistsExtra(context)
                }
              }
              resolve(true)
            } else {
              // it's QuerySnapshot (multi-doc)
              const docs = !snapshot.empty
                ? snapshot.docs.map((doc) => ({
                  '.key': doc.id,
                  id: doc.id,
                  ...doc.data()
                }))
                : []
              context.commit('set_' + sourceName, docs)
              resolve(true)
            }
          },
          (e) => {
            if (onSnapshotErrorExtra) {
              onSnapshotErrorExtra(context)
            }
            vm.$Sentry.captureException(e)
            reject(e)
          }
        )

        addBindingUnsubscribe(unsubscribe)
      } catch (e) {
        vm.$Sentry.captureException(e)
        reject(e)
      }
    })
  )

  return context.state[bindingName]
}
